
import { nullable, oneOfType } from 'vue-types';
import { CardProps } from './ContentBase.vue';

export default {
  props: {
    card: oneOfType([CardProps, nullable()]),
  },
};
